export default __webpack_public_path__ + "static/media/WhitePrinter.1f245095.svg";